// extracted by mini-css-extract-plugin
export default {"root":"PersonInfo_root__dJ2Ck","info":"PersonInfo_info__szjhn","name":"PersonInfo_name__nZVz4","description":"PersonInfo_description__rRBlv"};